<template>

    <div>
        <b-modal id="modal-categoria" ref="my-modal-categoria" :ok-title="btnGrabarCategoria" cancel-title="Cerrar"
            centered size="lg" :title="titleModalCategoria" @show="resetModalCategoria" @hidden="resetModalCategoria"
            @ok="handleOkCategoria">
            <validation-observer ref="simpleRulesCategoria">
                <form ref="formCategoria" @submit.stop.prevent="handleSubmitCategoria">
                    <b-form-group :state="descripcionStateCategoria" label="Descripción categoría"
                        label-for="descripcion-input-categoria" invalid-feedback="Se requiere la descripción">
                        <b-form-input id="descripcion-input-categoria" v-model="descripcionCategoria"
                            :state="descripcionStateCategoria" required placeholder="Descripción" />
                    </b-form-group>
                </form> 
            </validation-observer>
        </b-modal>

        <b-modal id="modal-sub-categoria" ref="my-modal-sub-categoria" :ok-title="btnGrabarSubCategoria"
            cancel-title="Cerrar" centered size="lg" :title="titleModalSubCategoria" @show="resetModalSubCategoria"
            @hidden="resetModalSubCategoria" @ok="handleOkSubCategoria">
            <validation-observer ref="simpleRulesSubCategoria">
                <form ref="formSubCategoria" @submit.stop.prevent="handleSubmitSubCategoria">
                    <b-form-group :state="descripcionStateSubCategoria" label="Descripción Sub Categoría"
                        label-for="descripcion-input-sub-categoria" invalid-feedback="Se requiere la descripción">
                        <b-form-input id="descripcion-input-sub-categoria" v-model="descripcionSubCategoria"
                            :state="descripcionStateSubCategoria" required placeholder="Descripción" />
                    </b-form-group>
                </form>
            </validation-observer>
        </b-modal>



        <div class="row">
            <div class="col-md-6 co-12">
                <b-card title="Categorias">

                    <b-row>
                        <b-col md="6" sm="8" class="my-1">
                            <b-form-group>
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    v-on:click="mostrarModalCategoria()" size="sm" variant="primary">
                                    Nuevo
                                </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col md="6" class="my-1">
                            <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                                label-for="filterInput" class="mb-0">
                                <b-input-group size="sm">
                                    <b-form-input id="filterInput" v-model="filter" type="search"
                                        placeholder="Escribe para buscar" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>


                        <b-col cols="12">

                            <b-table ref="selectableTable" small="small" selectable responsive
                                :select-mode="selectModeCategoria" :per-page="perPage" :current-page="currentPage"
                                :items="categorias" :fields="fieldsCategorias" :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                                :filter-included-fields="filterOn" @filtered="onFilteredCategorias"
                                @row-selected="onRowCategoriaSelected" :busy="cargandoCategoria" show-empty>

                                <template #empty="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros para mostrar</div>
                                    </div>
                                </template>
                                <template #emptyfiltered="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros que coincidan con su solicitud
                                        </div>
                                    </div>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-dark my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Cargando...</strong>
                                    </div>
                                </template>

                                <template #cell(id)="data">
                                    <b-input-group-append>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-success"
                                            class="btn-icon" v-on:click="editarCategoria(data.value)">
                                            <feather-icon icon="Edit2Icon" />
                                        </b-button>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                                            class="btn-icon" v-on:click="eliminarCategoria(data.value)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </b-input-group-append>
                                </template>

                            </b-table>
                        </b-col>

                        <b-col md="7" sm="8" class="my-1">
                            <b-form-group class="mb-0">
                                <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                                    class="w-50" />
                            </b-form-group>
                        </b-col>

                        <b-col md="5" class="my-1">
                            <b-pagination v-model="currentPage" :total-rows="totalRowsCategorias" :per-page="perPage"
                                align="center" size="sm" class="my-0" />
                        </b-col>
                    </b-row>

                </b-card>
            </div>

            <div class="col-md-6 co-12">
                <b-card title="Sub Categorias">

                    <b-row>

                        <b-col md="6" sm="8" class="my-1">
                            <b-form-group v-if="this.selectedCategoria !== undefined">
                                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    v-on:click="mostrarModalSubCategoria()" size="sm" variant="primary">
                                    Nuevo
                                </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col md="6" class="my-1">
                            <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                                label-for="filterInputS" class="mb-0">
                                <b-input-group size="sm">
                                    <b-form-input id="filterInputS" v-model="filterSubCategorias" type="search"
                                        placeholder="Escribe para buscar" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>


                        <b-col cols="12">
                            <b-table ref="selectableTable" responsive small="small" :per-page="perPageSubCategorias"
                                :current-page="currentPageSubCategorias" :items="subcategorias"
                                :fields="fieldsSubCategorias" :sort-by.sync="sortBySubCategorias"
                                :sort-desc.sync="sortDescSubCategorias" :sort-direction="sortDirectionSubCategorias"
                                :filter="filterSubCategorias" :filter-included-fields="filterOnSubCategorias"
                                @filtered="onFilteredSubCategorias" :busy="cargandoSubCategoria" show-empty>

                                <template #empty="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros para mostrar</div>
                                    </div>
                                </template>
                                <template #emptyfiltered="scope">
                                    <div role="alert" aria-live="polite">
                                        <div class="text-center my-2">No hay registros que coincidan con su solicitud
                                        </div>
                                    </div>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-dark my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Cargando...</strong>
                                    </div>
                                </template>

                                <template #cell(id)="data">
                                    <b-input-group-append>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-success"
                                            class="btn-icon" v-on:click="editarSubCategoria(data.value)">
                                            <feather-icon icon="Edit2Icon" />
                                        </b-button>
                                        <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                                            class="btn-icon" v-on:click="eliminarSubCategoria(data.value)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </b-input-group-append>
                                </template>

                            </b-table>
                        </b-col>

                        <b-col md="7" sm="8" class="my-1">
                            <b-form-group class="mb-0">
                                <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                                <b-form-select id="perPageSelectS" v-model="perPageSubCategorias" size="sm"
                                    :options="pageOptionsSubCategorias" class="w-50" />
                            </b-form-group>
                        </b-col>

                        <b-col md="5" class="my-1">
                            <b-pagination v-model="currentPageSubCategorias" :total-rows="totalRowsSubCategorias"
                                :per-page="perPageSubCategorias" align="center" size="sm" class="my-0" />
                        </b-col>
                    </b-row>

                </b-card>
            </div>


        </div>

    </div>


</template>

<script>
import axiosIns from '../../../libs/axios'
import {
    BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BModal, VBModal,
    BForm, BCardText, BSpinner
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
    components: {
        ValidationProvider, ValidationObserver,
        BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow,
        BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
        BInputGroupAppend, BButton, BModal, VBModal, BForm, BCardText, vSelect, Swal,
        BSpinner
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {
            cargandoCategoria: true,
            cargandoSubCategoria: true,
            perPage: 5,
            pageOptions: [3, 5, 10],
            totalRowsCategorias: 1,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fieldsCategorias: [
                { key: 'id', label: 'Opciones', },
                { key: 'key', label: 'ID', sortable: true },
                { key: 'descripcion', label: 'Descripcion', sortable: true },
                { key: 'fecha_creacion', label: 'Fecha de Creacion', sortable: true },
            ],
            selectModeCategoria: 'single',
            selectedCategoria: [],

            descripcionCategoria: '',
            descripcionStateCategoria: null,

            titleModalCategoria: "",
            btnGrabarCategoria: "",

            idCategoria: null,
            categorias: [],
            categoria: [],

            //Sub Categoria
            perPageSubCategorias: 5,
            pageOptionsSubCategorias: [3, 5, 10],
            totalRowsSubCategorias: 1,
            currentPageSubCategorias: 1,
            sortBySubCategorias: '',
            sortDescSubCategorias: false,
            sortDirectionSubCategorias: 'asc',
            filterSubCategorias: null,
            filterOnSubCategorias: [],
            infoModalSubCategorias: {
                id: 'info-modal-sub-categoria',
                title: '',
                content: '',
            },
            fieldsSubCategorias: [
                { key: 'id', label: 'Opciones', },
                { key: 'key', label: 'ID' },
                { key: 'descripcion', label: 'Descripcion', sortable: true },
                { key: 'fecha_creacion', label: 'Fecha de Creacion', sortable: true },
            ],
            selectModeSubCategoria: 'single',
            selectedSubCategoria: [],

            descripcionSubCategoria: '',
            descripcionStateSubCategoria: null,

            titleModalSubCategoria: "",
            btnGrabarSubCategoria: "",

            idSubCategoria: 0,
            subcategorias: [],
            subcategoria: [],

            respuesta: false,
        }
    },
    computed: {
        sortOptionsCategorias() {
            return this.fieldsCategorias
                .filter(f => f.sortable)
                .map(f => ({ text: f.label, value: f.key }))
        },
    },
    /*mounted() {
        this.totalRowsCategorias = this.categorias.length;
    },*/
    methods: {
        /*info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },*/
        onFilteredCategorias(filteredItems) {
            this.totalRowsCategorias = filteredItems.length
            this.currentPage = 1
        },
        obtenerCategorias() {
            this.cargandoCategoria = true;
            this.cargandoSubCategoria = false;
            this.categorias = [];

            const config = {
                method: 'get',
                url: '/sap/md/categoria/list/'
            };

            axiosIns(config)
                .then((response) => {
                  if (response.status === 200) {
                    // this.categorias = response.data;
                    response.data.forEach(element=>{
                        this.categorias.push({
                            id: element.id,
                            key: element.id,
                            descripcion: element.descripcion,
                            fecha_creacion: element.fecha_creacion,
                            estado: element.estado
                        })
                    })
                    this.totalRowsCategorias = this.categorias.length;
                  }
                })
                .catch((error) => {
                  console.log("=======error=======");
                  //this.obtenerCategorias();
                })
                .finally(() => {
                    this.cargandoCategoria = false;
                });

        },
        mostrarModalCategoria() {
            this.categoria = [];
            this.titleModalCategoria = "Crear Categoria";
            this.btnGrabarCategoria = "Guardar";
            this.descripcionCategoria = "";
            this.$refs['my-modal-categoria'].show();
        },
        editarCategoria(id) {
            this.categoria = [];
            this.titleModalCategoria = "Editar Categoria";
            this.btnGrabarCategoria = "Editar";
            this.idCategoria = id;

            const config = {
                method: 'get',
                url: '/sap/md/categoria/detalle/' + id,
            };

            axiosIns(config)
                .then((response) => {
                    //console.log(JSON.stringify(response.data));
                    if (response.status === 200) {
                        this.categoria = response.data;

                        this.descripcionCategoria = this.categoria.descripcion;

                        this.$refs['my-modal-categoria'].show();
                    }
                })
                .catch((error) => {
                    //console.log(error);
                })
                .finally(() => {
                    //this.cargandoCategoria = false;
                });


        },
        eliminarCategoria(id) {
            this.idCategoria = id;

            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger'
                },
                buttonsStyling: false
            });

            swalWithBootstrapButtons.fire({
                title: 'Desea eliminar la Categoria?',
                text: "No se podrá recuperar después eliminada!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar!',
                cancelButtonText: 'No, cancelar!',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {

                    this.deleteCategoria();

                } else if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    swalWithBootstrapButtons.fire(
                        'Cancelado',
                        'Su categoria no se elimino!',
                        'error'
                    )
                }
            });

        },
        deleteCategoria() {

            this.respuesta = false;

          const data = {
            'estado': '0'
          }

          const config = {
            method: 'put',
            url: '/sap/md/categoria/editar/' + this.idCategoria,
            data: data
          }

          axiosIns(config)
                .then((response) => {

                    if (response.status === 200) {
                        //console.log(response.data);
                        this.respuesta = true;
                        Swal.fire(
                            'Eliminado!',
                            'Su Categoria fue elimnada con éxito!',
                            'success'
                        );
                        this.obtenerCategorias();
                    }

                })
                .catch((error) => {
                    this.respuesta = false;
                    Swal.fire({
                        title: 'Error!',
                        text: ' No se elimino la Categoria!',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                    //return false;
                    //console.log(error);
                })
                .finally(() => {
                    //this.cargandoCategoria = false;
                });

            /*if (this.respuesta) {
                Swal.fire(
                    'Eliminado!',
                    'Su Categoria fue elimnada con éxito!',
                    'success'
                );
                this.obtenerCategorias();
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: ' No se elimino la Categoria!',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            }*/

        },
        checkFormValidityCategoria() {
            const valid = this.$refs.formCategoria.checkValidity()
            this.descripcionStateCategoria = valid
            return valid
        },
        resetModalCategoria() {
          this.descripcionStateCategoria = null
        },
        handleOkCategoria(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.handleSubmitCategoria()
        },
        handleSubmitCategoria() {

            if (!this.checkFormValidityCategoria()) {
                return
            }

          const fechaActual = moment()
              .format('YYYY-MM-DD')

          if (this.categoria.estado == 1) {

                const data = {
                    "descripcion": this.descripcionCategoria,
                };

                var config = {
                    method: 'put',
                    url: '/sap/md/categoria/editar/' + this.idCategoria,
                    data: data
                };

                axiosIns(config)
                    .then((response) => {
                        if (response.status === 200) {
                            this.obtenerCategorias();

                            this.$nextTick(() => {
                                this.$refs['my-modal-categoria'].toggle('#toggle-btn')
                            })

                            this.successEditado("Categoria");
                        }
                        //true;
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorEditado("Categoria");
                        //false;
                        //        console.log(error);
                    })
                    .finally(() => {
                        //this.cargandoCategoria = false;
                    });

            } else {
                const data = {
                    "descripcion": this.descripcionCategoria,
                    "fecha_creacion": fechaActual,
                    "estado": "1"
                };

                //this.respuesta = await saveCategoria(data);
                const config = {
                    method: 'post',
                    url: '/sap/md/categoria/crear/',
                    data: data
                };

                axiosIns(config)
                    .then((response) => {
                        if (response.status === 201) {
                            this.successRegistro("Categoria");

                            this.obtenerCategorias();

                            this.$nextTick(() => {
                                this.$refs['my-modal-categoria'].toggle('#toggle-btn')
                            })
                        }
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorRegistro("Categoria");
                    });

                /*if (this.respuesta) {
                    this.successRegistro("Categoria");
                } else {
                    this.errorRegistro("Categoria");
                }*/
            }


        },
        onRowCategoriaSelected(items) {
            this.selectedCategoria = items[0];
            this.subcategorias = [];
            this.obtenerSubCategorias();
        },
        successRegistro(texto) {
            Swal.fire({
                title: 'Registro exitoso!',
                text: texto + ' se registro de manera satisfactoria!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        },
        errorRegistro(texto) {
            Swal.fire({
                title: 'Error!',
                text: texto + ' no se registro!',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        successEditado(texto) {
            Swal.fire({
                title: 'Modificación exitoso!',
                text: texto + ' se modificó de manera satisfactoria!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        },
        errorEditado(texto) {
            Swal.fire({
                title: 'Error!',
                text: texto + ' no se modificó!',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },

        //Sub Categoria
        obtenerSubCategorias() {

            if (this.selectedCategoria !== undefined) {
                this.cargandoSubCategoria = true;
                /*this.subcategorias = await getSubCategoriasXCategoria(this.selectedCategoria.id);
                this.totalRowsSubCategorias = this.subcategorias.length;*/
                const config = {
                    method: 'get',
                    url: '/sap/md/subcategoria/list/',
                };

                axiosIns(config)
                    .then((response) => {
                      //console.log(response.data);
                      /*const objData = JSON.stringify(response.data);*/
                      const arrayData = response.data;

                      response.data.forEach(element=>{
                        if(element.categoria === this.selectedCategoria.id){
                            this.subcategorias.push({
                                id: element.id,
                                key: element.id,
                                descripcion: element.descripcion,
                                fecha_creacion: element.fecha_creacion,
                                estado: element.estado,
                                categoria: element.categoria
                            })
                        }
                      })

                    //   this.subcategorias = arrayData.filter((item) => {

                    //     return (item.categoria === this.selectedCategoria.id);
                    //   })

                      this.totalRowsSubCategorias = this.subcategorias.length

                      /*return arrayDataFilter;*/

                    })
                    .catch((error) => {
                        //console.log(error);
                        console.log("=======error=======");
                        // this.obtenerSubCategorias();
                        return false;
                    })
                    .finally(() => {
                        this.cargandoSubCategoria = false;
                    });
            }

        },
        onFilteredSubCategorias(filteredItems) {
            this.totalRowsSubCategorias = filteredItems.length
            this.currentPageSubCategorias = 1
        },
        resetModalSubCategoria() {
          this.descripcionStateSubCategoria = null
        },
        handleOkSubCategoria(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.handleSubmitSubCategoria()
        },
        async handleSubmitSubCategoria() {
            if (!this.checkFormValiditySubCategoria()) {
                return
            }

          const fechaActual = moment()
              .format('YYYY-MM-DD')

          if (this.idSubCategoria != 0) {

                var data = {
                    "categoria": this.selectedCategoria.id,
                    "descripcion": this.descripcionSubCategoria,
                };

                //this.respuesta = await editSubCategoria(data, this.idSubCategoria);

                var config = {
                    method: 'put',
                    url: '/sap/md/subcategoria/editar/' + this.idSubCategoria,
                    data: data
                };

                axiosIns(config)
                    .then((response) => {
                        if (response.status === 200) {
                            this.successEditado("Sub Categoria");

                            this.obtenerSubCategorias();

                            this.$nextTick(() => {
                                this.$refs['my-modal-sub-categoria'].toggle('#toggle-btn')
                            })
                        }
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorEditado("Sub Categoria");
                        //        console.log(error);
                    });

                /*if (this.respuesta) {
                    this.successEditado("Sub Categoria");
                } else {
                    this.errorEditado("Sub Categoria");
                }*/

            } else {
                var data = {
                    "categoria": this.selectedCategoria.id,
                    "descripcion": this.descripcionSubCategoria,
                    "fecha_creacion": fechaActual,
                    "estado": "1"
                };

                //this.respuesta = await saveSubCategoria(data);
                var config = {
                    method: 'post',
                    url: '/sap/md/subcategoria/crear/',
                    data: data
                };
//sub categoria 1 de categoria 2
                axiosIns(config)
                    .then((response) => {
                        if (response.status === 201) {
                            this.successRegistro("Sub Categoria");

                            this.obtenerSubCategorias();

                            this.$nextTick(() => {
                                this.$refs['my-modal-sub-categoria'].toggle('#toggle-btn')
                            })
                        }
                        //console.log(JSON.stringify(response.data));
                    })
                    .catch((error) => {
                        this.errorRegistro("Sub Categoria");
                        //        console.log(error);
                    });
            }


        },
        mostrarModalSubCategoria() {
            this.subcategoria = [];
            this.titleModalSubCategoria = "Crear Sub Categoria";
            this.btnGrabarSubCategoria = "Guardar";
            this.descripcionSubCategoria = "";
            this.$refs['my-modal-sub-categoria'].show();
        },
        editarSubCategoria(id) {
            this.subcategoria = [];
            this.titleModalSubCategoria = "Editar Sub Categoria";
            this.btnGrabarSubCategoria = "Editar";
            this.idSubCategoria = id;
            //this.subcategoria = await detalleSubCategoria(this.idSubCategoria);

          const config = {
            method: 'get',
            url: '/sap/md/subcategoria/detalle/' + this.idSubCategoria,
          }

          axiosIns(config)
                .then((response) => {
                    //console.log(JSON.stringify(response.data));
                    //return response.data;
                    if (response.status === 200) {

                        this.subcategoria = response.data;
                        this.descripcionSubCategoria = this.subcategoria.descripcion;

                        this.$refs['my-modal-sub-categoria'].show();
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    //return false;
                });


        },
        eliminarSubCategoria(id) {
            this.idSubCategoria = id;

            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger'
                },
                buttonsStyling: false
            });

            swalWithBootstrapButtons.fire({
                title: 'Desea eliminar la Sub Categoria?',
                text: "No se podrá recuperar después eliminada!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar!',
                cancelButtonText: 'No, cancelar!',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {

                    this.deleteSubCategoria();

                } else if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    swalWithBootstrapButtons.fire(
                        'Cancelado',
                        'Tu sub categoria no se elimino!',
                        'error'
                    )
                }
            });

        },
        async deleteSubCategoria() {

            //this.respuesta = await deleteSubCategoria(this.idSubCategoria, this.selectedCategoria.id);

          const data = {
            'categoria': this.selectedCategoria.id,
            'estado': '0'
          }

          const config = {
            method: 'put',
            url: '/sap/md/subcategoria/editar/' + this.idSubCategoria,
            data: data
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        Swal.fire(
                            'Eliminado!',
                            'Su Sub Categoria fue elimnada con éxito!',
                            'success'
                        );
                        this.obtenerSubCategorias();
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: 'Error!',
                        text: ' No se elimino la Sub Categoria!',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                });

            /*if (this.respuesta) {
                Swal.fire(
                    'Eliminado!',
                    'Su Sub Categoria fue elimnada con éxito!',
                    'success'
                );
                this.obtenerSubCategorias();
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: ' No se elimino la Sub Categoria!',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            }*/

        },
        checkFormValiditySubCategoria() {
            const valid = this.$refs.formSubCategoria.checkValidity()
            this.descripcionStateSubCategoria = valid
            return valid
        },

    },
    created() {
        this.obtenerCategorias();
        this.selectedCategoria = undefined;
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.b-table-selectable {
    .feather {
        font-size: 1.3rem;
    }
}
</style>
